import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Import Bootstrap JS for dropdowns
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

// Import custom CSS
import './assets/custom.css'

// Initialize auth state before mounting the app
store.dispatch('auth/initAuth')

// Check for dark mode preference
const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
const setInitialTheme = () => {
  // Get saved preference or use system preference
  const savedTheme = localStorage.getItem('theme')
  const theme = savedTheme || (darkModeMediaQuery.matches ? 'dark' : 'light')
  document.documentElement.setAttribute('data-theme', theme)
}

// Set initial theme
setInitialTheme()

createApp(App)
  .use(router)
  .use(store)
  .mount('#app')